export default "__VITE_ASSET__BLshQz9B__"